/**
 * ConfirmEmailChangePage — the link in the "confirm your new email" mail
 * lands here (/confirm-email?token=…). The server swaps the address; this
 * page says so and points back to sign-in, since the old sessions carry the
 * old address in their token.
 */
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { BACKEND_URL } from '../../utils/config';
import { AuthPage } from './AuthShell';
import './LoginPage.css';

export default function ConfirmEmailChangePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [status, setStatus] = useState(token ? 'working' : 'error'); // working | done | error
  const [email, setEmail] = useState('');
  const [error, setError] = useState(token ? '' : 'This link is missing its token.');

  useEffect(() => {
    if (!token) return;
    fetch(`${BACKEND_URL}/api/auth/confirm-email-change?token=${encodeURIComponent(token)}`)
      .then(r => r.json())
      .then(d => {
        if (d.success) { setEmail(d.email || ''); setStatus('done'); }
        else { setStatus('error'); setError(d.error || 'The change could not be confirmed.'); }
      })
      .catch(() => { setStatus('error'); setError('Cannot reach pidly right now.'); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthPage>
      {status === 'working' && <p className="login-subtitle">Confirming your new email…</p>}
      {status === 'done' && (
        <div className="login-verify">
          <svg className="login-verify-icon login-verify-icon--success" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
          </svg>
          <h2>Email changed</h2>
          <p>You now sign in with <strong>{email}</strong>. Your password is unchanged.</p>
          <button className="login-submit-btn" onClick={() => navigate('/login')}>Sign in</button>
        </div>
      )}
      {status === 'error' && (
        <div className="login-verify">
          <svg className="login-verify-icon login-verify-icon--error" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" />
          </svg>
          <h2>That did not work</h2>
          <p>{error}</p>
          <button className="login-submit-btn" onClick={() => navigate('/account')}>Back to your account</button>
        </div>
      )}
    </AuthPage>
  );
}
